
// Bible resources strings
export const DEFAULT_GATEWAY_LANGUAGE = 'en';
export const ORIGINAL_LANGUAGE = 'originalLanguage';
export const TARGET_LANGUAGE = 'targetLanguage';
export const TARGET_BIBLE = 'targetBible';
export const TRANSLATION_WORDS = 'translationWords';
export const TRANSLATION_WORDS_LINKS = 'translationWordsLinks';
export const TRANSLATION_NOTES = 'translationNotes';
export const TRANSLATION_ACADEMY = 'translationAcademy';
export const TRANSLATION_HELPS = 'translationHelps';
export const LEXICONS = 'lexicons';
export const UGL_LEXICON = 'ugl';
export const UHL_LEXICON = 'uhl';
export const NT_ORIG_LANG = 'el-x-koine';
export const NT_ORIG_LANG_BIBLE = 'ugnt';
export const OT_ORIG_LANG = 'hbo';
export const OT_ORIG_LANG_BIBLE = 'uhb';
export const OWNER_SEPARATOR = '_';
export const ELLIPSIS = '\u2026';
export const THREE_DOTS = '...';
export const FINISHED_KEY = 'finished';
export const INVALID_KEY = 'invalid';
export const UNALIGNED_KEY = 'unaligned';
export const EDITED_KEY = 'edited';
export const BOOKMARKED_KEY = 'bookMarked';
export const COMMENT_KEY = 'comment';
